function Header() {
  return (
    <>
      <header className="header">
        <div className=" container">
          <strong>Quiz App 🚀</strong>
        </div>
      </header>
    </>
  );
}
export default Header;
